import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-istyleguide',
    templateUrl: './istyleguide.component.html',
    styleUrls: ['./istyleguide.component.scss']
})
export class IstyleguideComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

    showBlockUi() {
    }

}
